function parseUrlSafe(raw) {
  try {
    return new URL(String(raw || ""));
  } catch {
    return null;
  }
}

function extractAssetIdFromPath(pathname = "") {
  const path = String(pathname || "");
  const apiMatch = path.match(/\/api\/v1\/media\/assets\/([^/]+)/i);
  if (apiMatch?.[1]) return apiMatch[1];

  const imgMatch = path.match(/\/img\/([^/]+)\//i);
  if (imgMatch?.[1]) return imgMatch[1];

  return "";
}

export function normalizeAegisHeroWebpUrl(rawUrl) {
  const source = String(rawUrl || "").trim();
  if (!source) return "";

  const parsed = parseUrlSafe(source);
  if (!parsed) return source;

  const assetId = extractAssetIdFromPath(parsed.pathname);
  if (!assetId) return source;

  return `${parsed.origin}/img/${assetId}/hero.webp`;
}

